import React from 'react';
import { Box, Alert, Typography } from '@mui/material';
import QuizRunner from '../../components/Quiz/QuizRunner';
import { StaticQuizDTO } from '../../services/quizService';

const MOCK_PREVIEW_QUIZ: StaticQuizDTO = {
    id: 999,
    topicId: 0,
    title: "Preview Quiz",
    type: 'STATIC',
    status: 'DRAFT',
    questions: [
        {
            id: "q1",
            type: 'MCQ',
            content: "### Sample Question\nWhat is the capital of France?",
            options: ["London", "Paris", "Berlin", "Madrid"],
            correctAnswer: "Paris",
            points: 1
        },
        {
            id: "q2",
            type: 'TRUE_FALSE',
            content: "The earth is flat.",
            options: ["True", "False"],
            correctAnswer: "False",
            points: 1
        }
    ],
    timeLimitMinutes: 10,
    minPassPercent: 70
};

const QuizPreviewWrapper: React.FC = () => {
    return (
        <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
            <Alert
                severity="info"
                sx={{
                    borderRadius: 0,
                    mb: 0,
                    borderBottom: '1px solid #e0e0e0',
                    justifyContent: 'center',
                    '& .MuiAlert-message': { width: '100%', textAlign: 'center' }
                }}
            >
                <Typography variant="body2" component="span" fontWeight="bold">
                    Student View Preview Mode:
                </Typography>
                {' '} You are taking this quiz as a preview. Results will NOT be saved.
            </Alert>
            <Box sx={{ flexGrow: 1 }}>
                <QuizRunner
                    quiz={MOCK_PREVIEW_QUIZ}
                    mode="PREVIEW"
                    onComplete={() => alert("Preview Completed! (In real mode, this would show results)")}
                    onExit={() => window.history.back()}
                />
            </Box>
        </Box>
    );
};

export default QuizPreviewWrapper;
